/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import sanitizeIds from '../Utilities/id/sanitizeIds.js';
import { useTranslation } from '../Utilities/i18n/i18n.js';

var NoResultsDark = function NoResultsDark(_ref) {
  var id = _ref.id,
    ariaLabelProp = _ref.ariaLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ariaLabel = ariaLabelProp || t('No results icon');
  var uniqueId = id || Math.floor(1000 + Math.random() * 9000);
  var gradientIds = sanitizeIds(['icon--noresults--linear-gradient', 'icon--noresults--linear-gradient-2', 'icon--noresults--linear-gradient-3', 'icon--noresults--linear-gradient-4', 'icon--noresults--linear-gradient-5', 'icon--noresults--linear-gradient-6'], uniqueId);
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": ariaLabel,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--noresults--linear-gradient'],
    x1: "2.6",
    x2: "43.48",
    y1: "-12.81",
    y2: "58",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".69",
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".94",
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#393939"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--noresults--linear-gradient-2'],
    x1: "43.74",
    x2: "69.51",
    y1: "57.08",
    y2: "57.08",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#393939"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--noresults--linear-gradient-3'],
    x1: "15.1",
    x2: "41.51",
    y1: "10.36",
    y2: "56.09",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--noresults--linear-gradient-4'],
    x1: "34.92",
    x2: "34.92",
    y1: "-46.56",
    y2: "97.82",
    gradientTransform: "rotate(30 34.92 27.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".48",
    stopColor: "#393939",
    stopOpacity: ".69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#262626",
    stopOpacity: ".1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--noresults--linear-gradient-5'],
    x1: "24.56",
    x2: "50.36",
    y1: "9.61",
    y2: "54.3",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#6f6f6f",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".17",
    stopColor: "#6f6f6f",
    stopOpacity: ".03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".31",
    stopColor: "#6f6f6f",
    stopOpacity: ".12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".44",
    stopColor: "#6f6f6f",
    stopOpacity: ".28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".56",
    stopColor: "#6f6f6f",
    stopOpacity: ".49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".68",
    stopColor: "#6f6f6f",
    stopOpacity: ".77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".73",
    stopColor: "#6f6f6f",
    stopOpacity: ".92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#6f6f6f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--noresults--linear-gradient-6'],
    x1: "15.86",
    x2: "56.75",
    y1: "-20.5",
    y2: "50.32",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".69",
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".94",
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#262626"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['icon--noresults--linear-gradient'], ")"),
    d: "M12.69 17.95c0 12.04 8.75 26.85 19.56 33.09 5.64 3.26 10.73 3.52 14.3 1.32l4.82-2.78-1.19-1.93c-3.24 1.73-7.72 1.38-12.66-1.48-9.9-5.72-17.92-19.29-17.92-30.32 0-5.1 1.71-8.75 4.53-10.65l-1.2-1.96-4.83 2.8c-3.36 1.97-5.42 6.08-5.42 11.91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['icon--noresults--linear-gradient-2'], ")"),
    d: "M67.31 64.92s.11.86-1.89 2.24-2.73 1.18-2.73 1.18L48.57 49.22l4.62-3.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['icon--noresults--linear-gradient-3'], ")"),
    d: "M37.68 46.05c-9.9-5.71-17.93-19.29-17.93-30.32 0-3.79.95-6.78 2.6-8.85-4.87.76-8.09 5.04-8.09 12.02 0 11.03 8.03 24.6 17.93 30.32 6.5 3.75 12.19 3.19 15.33-.76-2.83.44-6.2-.3-9.84-2.4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "34.92",
    cy: "27.57",
    fill: "url(#".concat(gradientIds['icon--noresults--linear-gradient-4'], ")"),
    opacity: ".5",
    rx: "14.55",
    ry: "25.2",
    transform: "rotate(-30 34.93 27.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1 75L54.26 67.6c1.1-1.15 1.1-2.36-.77-3.44l-.05-.02L26.17 48.4l-.09-.06c-2.6-1.5-5.82-1.05-8.41.45s-3.58 3.48-.99 4.98l27.41 15.8a7.17 7.17 0 005.5.54l12.98 7.51c1.25.72 5.78-1.89 4.53-2.61z",
    opacity: ".25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['icon--noresults--linear-gradient-5'], ")"),
    d: "M42.88 50.8a16.4 16.4 0 01-8.06-2.47C24.94 42.62 16.9 28.69 16.9 17.28c0-5.57 1.9-9.73 5.32-11.72s7.98-1.53 12.8 1.25c9.9 5.7 17.93 19.64 17.93 31.05 0 5.57-1.89 9.73-5.32 11.71a9.37 9.37 0 01-4.75 1.22zM26.97 4.75a8.96 8.96 0 00-4.54 1.17c-3.3 1.9-5.12 5.93-5.12 11.35 0 11.28 7.95 25.04 17.72 30.68 4.7 2.71 9.1 3.16 12.4 1.25s5.1-5.94 5.1-11.35c0-11.28-7.94-25.05-17.7-30.69a16 16 0 00-7.86-2.4z",
    opacity: ".6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['icon--noresults--linear-gradient-6'], ")"),
    d: "M57.02 37.5c0-12.03-8.75-26.84-19.56-33.08-5.64-3.26-10.73-3.53-14.3-1.33l-4.82 2.78 1.18 1.94c3.25-1.74 7.72-1.38 12.67 1.47C42.09 15 50.1 28.58 50.1 39.6c0 4.85-1.55 8.4-4.14 10.37-.12.1-1.17.73-1.3.82l2.11 1.42 4.83-2.79c3.35-1.98 5.42-6.09 5.42-11.92"
  }));
};
NoResultsDark.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string
};
var NoResultsDark$1 = NoResultsDark;

export { NoResultsDark$1 as default };
